module.exports = __webpack_public_path__ + "static/twitter-0a1fac777b2cef9ef8013641476deb81.png";